import axios from "axios"
const BASE_URL = 'https://api.cannolii.ir'

export const get = async (url, config = {}) => {
  return await axios.get(`${BASE_URL}${url}`, config)
}

export const post = async (url, body, config) => {
  return await axios.post(`${BASE_URL}${url}`, body, config)
}

export const put = async (url, body, config) => {
  return await axios.put(`${BASE_URL}${url}`, body, config)
}

export const deleteItem = async (url) => {
  return await axios.delete(`${BASE_URL}${url}`)
}

export const getUrl = async (url, config = {}) => {
  return await axios.get(`${url}`, config)
}
